import type { CountryKey, Faq, LocaleCode } from "~/types";

export default {
  en: {},
  ru: {
    india: [
      {
        q: "Гражданам каких стран мы оформляем визу в Индию?",
        a: "Гражданам России, Беларуси, Казахстана, Узбекистана и гражданам любых других стран."
      }
    ]
  },
  sv: {},
  he: {},
  'ru-KZ': {}
} satisfies Record<LocaleCode, Partial<Record<CountryKey, Faq[]>>>;